// extracted by mini-css-extract-plugin
export default {"flex-center":"login_flex-center__d28-E","flex-vertical-center":"login_flex-vertical-center__MnX7+","login":"login_login__qSpAq","panel":"login_panel__HzGrn"};